import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { fetchLocalUser } from 'store/action/user.action';
import GlobalStyle from 'style/global';
import Routes from './routes';
import { ToastContainer } from 'react-toastify';
import history from 'config/history';
import { Router } from 'react-router-dom';

class App extends PureComponent {
  componentDidMount() {
    this.props.fetchLocalUser();
    const captured = /code=([^&]+)/.exec(window.location.href); // Value is in [1] ('384' in our case)
    const result = captured ? captured[1] : null;
    if (result) {
      localStorage.setItem('code', result);
      window.close();
    }
  }

  render() {
    return (
      <>
        <Router history={history}>
          <ToastContainer autoClose={4000} position="bottom-right" />
          <GlobalStyle />
          <Routes />
        </Router>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchLocalUser: () => dispatch(fetchLocalUser()),
  };
}

export default connect(null, mapDispatchToProps)(App);
